import React, { FC, useEffect, useState } from 'react';

import useJoiValidation from '../hooks/useJoiValidation';
import { imageInteractiveComponentSchema } from './ImageInteractiveComponent.schema';
import { IImageInteractiveComponentProps } from './models';
import DangerouslySetInnerHtml from '../DangerouslySetInnerHtml';
import './style.scss';

const ImageInteractiveComponent: FC<IImageInteractiveComponentProps> = ({
    itemList,
    mainImage,
    content,
}) => {
    const { data, }: { data: IImageInteractiveComponentProps; } = useJoiValidation(imageInteractiveComponentSchema, 'ImageinteractiveComponent', {
        itemList,
        mainImage,
        content
    });

    const [showProduct, setShowProduct] = useState("");
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const closeModal = () => {
            setShowModal(false);
            setShowProduct("");
        }
        const modalEle = document.querySelector(`#${showProduct}-close`);
        if (showModal) modalEle?.addEventListener('click', closeModal);
        return () => modalEle?.removeEventListener("click", closeModal);
    }, [showProduct, showModal]);

    useEffect(() => {
        if (showProduct !== "") {
            document.querySelectorAll(".modal-btn")?.forEach(btn => {
                btn.classList.remove("show");
                btn.classList.add("hide");
            });
            document.querySelector(`#${showProduct}`)?.classList.replace("hide", "show");
        }
    }, [showProduct]);

    const handleClick = (item) => {
        setShowModal(true);
        setShowProduct(item.split(' ').join(''));
    };

    return (
        <div className="cds-section cds-page-block bathroom-interactive cds-section--no-double-spacing">
            <div className="bathroom-interactive__image">
                <img src={data.mainImage.url} alt='Bathroom Interactives' className='img' />
                {data?.itemList?.split(",")?.map((item, i) => (
                    <button type='button' key={i} onClick={() => handleClick(item)} className={`bathroom-interactive__image-close-btn target-${i + 1}`}><span>{i + 1}</span></button>
                ))}
            </div>
            <div className="bathroom-interactive__mobile-scroll">
                <span>Swipe to see more</span>
            </div>
            <div className="bathroom-interactive__modal">
                {showModal && <DangerouslySetInnerHtml html={data.content} className='modal' />}
            </div>
        </div>
    );
};

export default ImageInteractiveComponent;
